import * as React from 'react';

import { IEventSearch } from '@/client/legacy-shared-modules/search/search-types';
import { EventHit } from '@/imports/ui/components/search/EventHits';

import { CardDividerList } from '../shared/CardDividerList';

export const EventsList: React.FC<{
  hits: IEventSearch[];
}> = ({ hits }) => {
  if (hits.length === 0) {
    return null;
  }

  return (
    <CardDividerList>
      {hits.map((eventHit) => (
        <EventHit
          key={eventHit.objectID}
          hit={eventHit}
          variant="default"
          disableHighlight
        />
      ))}
    </CardDividerList>
  );
};
